import React from "react";
import styled from "@emotion/styled";
import { FILTER_PRESETS } from "../hooks/useBeautifyCamera";

export default function FilterSelector({ filterId, onFilterChange, beautify, onBeautifyChange }) {
  return (
    <Panel>
      <Strip>
        {FILTER_PRESETS.map((preset) => (
          <Swatch key={preset.id} onClick={() => onFilterChange(preset.id)} type="button">
            <SwatchCircle active={filterId === preset.id} style={{ background: preset.swatch }} />
            <SwatchLabel>{preset.label}</SwatchLabel>
          </Swatch>
        ))}
      </Strip>

      <BeautifyRow>
        <BeautifyLabel htmlFor="beautify-slider">Beautify</BeautifyLabel>
        <input
          id="beautify-slider"
          type="range"
          min={0}
          max={100}
          value={beautify}
          onChange={(e) => onBeautifyChange(Number(e.target.value))}
        />
        <BeautifyValue>{beautify}%</BeautifyValue>
      </BeautifyRow>
    </Panel>
  );
}

const Panel = styled.div`
  background: rgba(17, 17, 17, 0.55);
  backdrop-filter: blur(6px);
  border-radius: 14px;
  padding: 10px 12px;
`;

const Strip = styled.div`
  display: flex;
  gap: 14px;
  overflow-x: auto;
  padding-bottom: 6px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Swatch = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
`;

const SwatchCircle = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.active ? "#f97316" : "transparent")};
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);
`;

const SwatchLabel = styled.span`
  font-size: 10px;
  color: #fff;
  opacity: 0.85;
`;

const BeautifyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const BeautifyLabel = styled.label`
  font-size: 11px;
  color: #fff;
  opacity: 0.85;
  width: 52px;
`;

const BeautifyValue = styled.span`
  font-size: 11px;
  color: #fff;
  width: 32px;
  text-align: right;
`;
